import {Organisation} from '@eitje/api'
import {OrganisationDropdownItem, EnvironmentDropdownItem, BillingInfoDropdownItem} from './dropdown_items'
import {DropdownItem} from '@eitje/web_components'

export const OrganisationDropdown = ({id}) => {
	const {environment_ids, billingInfos} = Organisation.useFind(id, {joins: ['billingInfos']})
	const billingInfoId = billingInfos[0]?.id //TODO: remove safety operator once no missing data

	return (
		<>
			<OrganisationDropdownItem id={id} icon="eye-open" />
			<DropdownItem iconLeft="pencil" t="common.edit" modalLink={`/firms/organisations/${id}/edit`} />
			<EnvironmentDropdownItem ids={environment_ids} />
			<BillingInfoDropdownItem id={billingInfoId} />
		</>
	)
}
